import React, { useState } from 'react';
import { Button, Pagination, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { PaginationProps } from 'antd/lib/pagination';
import { CONSTANT } from '../../../../config/Constant';
import { LockOutlined, AuditOutlined } from '@ant-design/icons';

import LockState from './LockState';
import LegalState from './LegalState';

interface DataType {
  key: string;
  // id: string | any;
  request_id: string;
  phone_number: string;
  current_provider_code: string;
  ported: string;
  ported_from: string;
  ported_at: string;
  legal: string;
  to_provider: string;
  network_type: string;
  number_type: string;
  number: string;
  to_number: string;
  in_process: string | any;
  identification_value: string;
  identification_value2nd: string;
  identification_value3rd: string;
  from_provider: string;
  process_status: string;
  created_date: string | any;
}

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getList,
    savePayload,
    isPagination,
  } = props;

  const [openUpdateModal, setOpenUpdateModal] = useState<boolean>(false);
  const [openUpdateData, setOpenUpdateData] = useState<any>();

  const [openCancelModal, setOpenCancelModal] = useState<boolean>(false);
  const [openCancelData, setOpenCancelData] = useState<any>();

  const data: DataType[] = listData?.map((item, index) => ({
    key: index?.toString(),
    // id: item?.id ?? index + 1,
    phone_number: item?.phone_number,
    current_provider_code: item?.current_provider_code,
    ported: item?.ported,
    ported_from: item?.ported_from,
    ported_at: item?.ported_at,
    legal: item?.legal,
    request_id: item?.request_id,
    to_provider: item?.to_provider,
    network_type: item?.network_type,
    number_type: item?.number_type,
    number: item?.number,
    to_number: item?.to_number,
    in_process: item?.in_process,
    identification_value: item?.identification_value,
    identification_value2nd: item?.identification_value2nd,
    identification_value3rd: item?.identification_value3rd,
    from_provider: item?.from_provider,
    process_status: item?.process_status,
    created_date: item?.created_date,
  }));

  const columns: ColumnsType<DataType> = [
    // {
    //   title: 'ID',
    //   dataIndex: 'id',
    //   key: 'id',
    //   width: 80,
    //   fixed: 'left',
    //   sortDirections: ['descend', 'ascend'],
    //   sorter: (a, b) => a.id.toString().localeCompare(b.id),
    // },

    {
      title: 'Number',
      children: [
        {
          title: 'Phone Number',
          dataIndex: 'phone_number',
          key: 'phone_number',
          width: 180,

          sortDirections: ['descend', 'ascend'],
          sorter: (a, b) => (a.phone_number || '').localeCompare(b.phone_number || ''),
          render: (_, record) => {
            return record?.phone_number ? record?.phone_number : CONSTANT.NO_DATA_FOUND;
          },
        },
        {
          title: 'To Number',
          dataIndex: 'to_number',
          key: 'to_number',
          width: 180,

          sortDirections: ['descend', 'ascend'],
          sorter: (a, b) => (a.to_number || '').localeCompare(b.to_number || ''),
          render: (_, record) => {
            return record?.to_number ? record?.to_number : CONSTANT.NO_DATA_FOUND;
          },
        },
      ],
    },
    {
      title: 'Provider Code',
      children: [
        {
          title: 'Current',
          dataIndex: 'current_provider_code',
          key: 'current_provider_code',
          width: 180,

          sortDirections: ['descend', 'ascend'],
          sorter: (a, b) => (a.current_provider_code || '').localeCompare(b.current_provider_code || ''),
          render: (_, record) => {
            return record?.current_provider_code ? record?.current_provider_code : CONSTANT.NO_DATA_FOUND;
          },
        },
        {
          title: 'To',
          dataIndex: 'to_provider',
          key: 'to_provider',
          width: 180,

          sortDirections: ['descend', 'ascend'],
          sorter: (a, b) => (a.to_provider || '').localeCompare(b.to_provider || ''),
          render: (_, record) => {
            return record?.to_provider ? record?.to_provider : CONSTANT.NO_DATA_FOUND;
          },
        },
      ],
    },

    {
      title: 'Network Type',
      dataIndex: 'network_type',
      key: 'network_type',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.network_type || '').localeCompare(b.network_type || ''),
      render: (_, record) => {
        return record?.network_type ? record?.network_type : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: 'Number Type',
      dataIndex: 'number_type',
      key: 'number_type',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.number_type || '').localeCompare(b.number_type || ''),
      render: (_, record) => {
        return record?.number_type ? record?.number_type : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: 'Identification Value',
      dataIndex: 'identification_value',
      key: 'identification_value',
      width: 180,
      //
      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.identification_value || '').localeCompare(b.identification_value || ''),
      render: (_, record) => {
        return record?.identification_value ? record?.identification_value : CONSTANT.NO_DATA_FOUND;
      },
    },

    {
      title: 'Ported',
      dataIndex: 'ported',
      key: 'ported',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.ported || '').localeCompare(b.ported || ''),
      render: (_, record) => {
        return record?.ported ? record?.ported : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: 'Ported From',
      dataIndex: 'ported_from',
      key: 'ported_from',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.ported_from || '').localeCompare(b.ported_from || ''),
      render: (_, record) => {
        return record?.ported_from ? record?.ported_from : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: 'Ported At',
      dataIndex: 'ported_at',
      key: 'ported_at',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.ported_at || '').localeCompare(b.ported_at || ''),
      render: (_, record) => {
        return record?.ported_at ? record?.ported_at : CONSTANT.NO_DATA_FOUND;
      },
    },

    {
      title: 'Process Status',
      dataIndex: 'in_process',
      key: 'in_process',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.number || '').localeCompare(b.number || ''),
      render: (_, record) => {
        return record?.in_process === true
          ? 'In Process'
          : record?.in_process === false
            ? 'Not In Process'
            : CONSTANT.NO_DATA_FOUND;
      },
    },

    {
      title: 'Legal',
      dataIndex: 'legal',
      key: 'legal',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.legal || '').localeCompare(b.legal || ''),
      render: (_, record) => {
        return record?.legal ? record?.legal : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.created_date?.toString().localeCompare(b?.created_date),
      render: (_, record) => {
        return record?.created_date
          ? record?.created_date
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: 'Action',
      key: 'action',
      width: 150,
      fixed: 'right',
      // hidden: !checkPrivileges(userRoles, 'admin'),
      render: (_, record, index) => (
        <Space
          size="middle"
          wrap
        >
          <Tooltip
            title={
              record?.process_status === 'Complete'
                ? "Can't Update it. This request is already closed."
                : 'Lock State Request'
            }
          >
            <Button
              onClick={() => {
                handleUpdateRequest(record);
              }}
              icon={<LockOutlined />}
              type="default"
              disabled={record?.process_status === 'Complete' ? true : false}
              className="iconBtn"
            />
          </Tooltip>
          <Tooltip
            title={
              record?.process_status === 'Complete'
                ? "Can't Update it. This request is already closed."
                : 'Legal State Request'
            }
          >
            <Button
              onClick={() => {
                handleCancelRequest(record);
              }}
              icon={<AuditOutlined />}
              type="default"
              // className='cancelBtn'
              disabled={record?.process_status === 'Complete' ? true : false}
              className="iconBtn"
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleUpdateRequest = (record: any) => {
    setOpenUpdateModal(!openUpdateModal);
    setOpenUpdateData(record);
  };

  const handleCancelRequest = (record: any) => {
    setOpenCancelModal(!openCancelModal);
    setOpenCancelData(record);
  };

  //   const handleCancelRequestClose = (record: any) => {
  //     setOpenCancelModal(false);
  //     setOpenCancelData({});
  //   };

  const handleChange: PaginationProps['onChange'] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps['onShowSizeChange'] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={'fixed'}
        />
      </div>
      {isPagination ? (
        <div className="text-center mt-20 mb-30">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.current}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size ?? 10}
            showSizeChanger={totalData ? true : false}
            // showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      ) : null}
      <LockState
        handleUpdateRequest={handleUpdateRequest}
        openUpdateModal={openUpdateModal}
        openUpdateData={openUpdateData}
        getList={getList}
      />

      <LegalState
        handleCancelRequest={handleCancelRequest}
        openCancelModal={openCancelModal}
        openCancelData={openCancelData}
        getList={getList}
      />

      {/* <CancelRequest
        title={openCancelData?.request_id}
        close={handleCancelRequestClose}
        open={openCancelModal}
        deleteValues={openCancelData}
        name={'Request ID'}
        getList={getList}
      /> */}
    </>
  );
};
export default ListTable;
